import type { User } from "@/types/user";
import { api } from "./api-client";

/** BFF-Route des aggregierten Profils (User-Objekt inkl. registerSteps). */
const PROFILE_PATH = "/api/v3/user/profile";

/**
 * Entpackt die Profilantwort des BFF zum reinen User-Objekt.
 *
 * Der BFF liefert `{ data: User }`. Reicht das Backend seinerseits ein bereits
 * gewrapptes Objekt durch, kommt `{ data: { data: User } }` an — dieser Fall
 * wird hier mit aufgelöst.
 *
 * Alle Schreiber des Query-Caches (useUser, die Session-Probe, der Prefetch der
 * Root-Route) müssen dieselbe Form ablegen wie `useUser` liest. Steht dort die
 * gewrappte Antwort, sieht useUser ein leeres Objekt: Name, Coins und Bild
 * fehlen, bis ein Refetch die Form richtigstellt.
 *
 * `user.registerSteps` hängt genauso daran: Steht die gewrappte Form im Cache,
 * schickt die Register-Steps-Seite den Kunden mit unvollständigem Profil in die
 * Suche, statt ihn seine Angaben vervollständigen zu lassen.
 */
export function unwrapUserResponse(response: { data: User }): User {
	const user = response.data;
	if (user && "data" in user && !("name" in user)) {
		return (user as unknown as { data: User }).data;
	}
	return user;
}

/** Profil beim BFF holen und entpackt zurückgeben. */
export async function fetchUserProfile(signal?: AbortSignal): Promise<User> {
	return unwrapUserResponse(await api.get<{ data: User }>(PROFILE_PATH, signal));
}
